//function to resize tiny MCE mceBottomVars container
ht.bottomVarResize = function () {
  var padding =
    parseInt($('div.mceBottomVars').css('paddingRight').replace('px', '')) +
    parseInt($('div.mceBottomVars').css('paddingLeft').replace('px', ''));
  $('div.mceBottomVars').width($('table.mceLayout').width() - padding);
};
